import { CookieValueTypes, getCookie } from 'cookies-next';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { Translate } from 'next-translate';
import getT from 'next-translate/getT';
import { RedisClientType, RedisFunctions, RedisModules, RedisScripts } from 'redis';
import { SSRExchange, ssrExchange } from 'urql';
import { DomainConfigType, getDomainConfig } from 'utils/Domain/Domain';

export const getServerSidePropsWrapper =
    (
        callback: (props: {
            redisClient: RedisClientType<RedisModules, RedisFunctions, RedisScripts>;
            domainConfig: DomainConfigType;
            ssrExchange: SSRExchange;
            t: Translate;
            userConsentCookie: CookieValueTypes;
        }) => GetServerSideProps,
    ): any =>
    async (context: GetServerSidePropsContext) => {
        const userConsentCookie = getCookie('userConsentCookie', { req: context.req, res: context.res });
        const domainConfig = getDomainConfig(context.req.headers.host!);
        const createRedisClient = (await import('redis')).createClient;
        const redisClient = createRedisClient({
            url: `redis://${process.env.REDIS_HOST}`,
            socket: {
                connectTimeout: 5000,
            },
        });
        await redisClient.connect();

        const t = await getT(domainConfig.defaultLocale, 'common');
        const initServerSideProps = callback({
            redisClient,
            domainConfig,
            ssrExchange: ssrExchange({ isClient: false }),
            t,
            userConsentCookie,
        });
        const serverSideProps = await initServerSideProps(context);

        redisClient.disconnect();

        if (!('props' in serverSideProps)) {
            return serverSideProps;
        }

        return {
            ...serverSideProps,
            props: {
                ...(await serverSideProps.props),
            },
        };
    };
